import api from './api';

// Service du module « Google Search Console » (référencement naturel / SEO).
const gscApi = {
  // Liste des sites (propriétés) accessibles au compte de service.
  getSites: () => api.get('/search-console/sites'),

  // Rapport complet pour un site + période. compare = comparaison vs période précédente.
  getReport: ({ site, start, end, compare }) =>
    api.get('/search-console/report', {
      params: { site, start, end, compare: compare ? 1 : 0 },
    }),

  // KPIs consolidés de tous les sites.
  getOverview: ({ start, end }) =>
    api.get('/search-console/overview', { params: { start, end } }),

  // Audit IA SEO d'un site.
  getAudit: (site) => api.get('/search-console/audit', { params: { site } }),
  runAudit: (site) => api.post('/search-console/audit', { site }),
};

export default gscApi;
